import script from "./ChooseAmzonSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChooseAmzonSku.vue?vue&type=script&lang=ts&setup=true"

import "./ChooseAmzonSku.vue?vue&type=style&index=0&id=65439d30&lang=scss&scoped=true"
import "./ChooseAmzonSku.vue?vue&type=style&index=1&id=65439d30&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65439d30"]])

export default __exports__